export class MobileNetworks {
  static networksLogoPath = {
    MTN_NG : 'assets/img/networks/network-logo-mtn.jpg',
    AIRTEL_NG : 'assets/img/networks/network-logo-airtel.jpg',
    ETISALAT_NG : 'assets/img/networks/network-logo-9mobile.jpg',
    GLO_NG : ' assets/img/networks/network-logo-glo.jpg'
  }
}



// WEBPACK FOOTER //
// ./src/app/util/mobile-networks.ts